import React, { Component } from 'react';

import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import AddIcon from 'material-ui-icons/Add';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import styles from 'constants/styles';

export class AddLayerButton extends Component {
  render(){
    const { classes }  = this.props;
    return (
      <div className={ classes.floatingAction }>
        <Link to="/app/layers/new">
          <Button
            variant="fab"
            color="primary"
            className={ classes.button }
          >
            <AddIcon />
          </Button>
        </Link>
      </div>
    );
  }
}

AddLayerButton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AddLayerButton);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/StackupEditor/AddLayerButton.js